export function isFeedieEmail(email?: string): boolean {
  if (!email) {
    return false
  }

  if (email.endsWith('@feedyou.ai')) {
    return true
  }

  if (email.endsWith('@feedyou.agency')) {
    return true
  }

  return false
}

const DEVELOPERS = [
  'jan.dvorak',
  'jan.badura',
  'martin.maly',
  'marek.zdrazil',
  'michal.kurz',
  'lukas.secky',
  'frantisek.prochazka',
  'lukas.cejka',
  'kristina.svitacova'
]

export function isDeveloperEmail(email?: string): boolean {
  if (!isFeedieEmail(email)) {
    return false
  }

  if (email && DEVELOPERS.includes(email.split('@')[0])) {
    return true
  }

  return false
}
